import { ICardMotorsportsCalendar, CardMotorsportsCalendar } from "@sky-it-livedata/livedata-sports-design-system";

import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import { DataCardCalendarQuery } from "./types";

import transformQuery from "./transformers/query-transformer";
import { useIntcmp } from "../../hooks/useIntcmp";

export const setCustomAttributes = ({
  variables,
}: WidgetContext<DataCardCalendarQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

export const getServerProps = ({
  props,
}: WidgetContext<DataCardCalendarQuery>): ICardMotorsportsCalendar => {
  return transformQuery(props);
}

const ResultsContainer = ({
  props,
  ...rest
}: WidgetContext<ICardMotorsportsCalendar>) => {
  log({ props, ...rest });
  const intCmpEventHandler = useIntcmp();

  return (
    <div onClick={intCmpEventHandler}>
        <CardMotorsportsCalendar {...props} />
    </div>
  );
}

export default ResultsContainer;